import { render, staticRenderFns } from "./add_news.vue?vue&type=template&id=2d675fcf&"
import script from "./add_news.vue?vue&type=script&lang=js&"
export * from "./add_news.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/nsdua/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d675fcf')) {
      api.createRecord('2d675fcf', component.options)
    } else {
      api.reload('2d675fcf', component.options)
    }
    module.hot.accept("./add_news.vue?vue&type=template&id=2d675fcf&", function () {
      api.rerender('2d675fcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/page/_admin/add_news.vue"
export default component.exports